<template>
  <unicom-layout-pagina>
    <div class="grande fonte-primaria negrito cor-principal">
      Oops! :( Erro {{ codigoErro }}
    </div>
    <br />
    <div class="fonte-primaria subtitulo">
      {{ objetoErros[codigoErro] }}
    </div>
  </unicom-layout-pagina>
</template>

<script>
export default {
  data() {
    return {
      codigoErro: 0,
      objetoErros: {
        403: "Você não tem permissão para acessar esta página..."
      }
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      const { params } = this.$route;
      this.codigoErro = params.tipoErro;
    }
  }
};
</script>
